import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map, of } from "rxjs";
import { MENU_COMEDOR_SEDE, MenuComedorSedeRecord, MenuComedorSedeStatus } from "src/common/menuComedor";

@Injectable()
export class MenuComedorService {

	private readonly BASE_URL: string = environment.backendUrl + '/menu-comedor';	
	private readonly MENU_COMEDOR_URL: string = this.BASE_URL;
	private readonly MENU_COMEDOR_STATUS_URL: string = this.BASE_URL + '/status';

	private readonly SEDE_PARAM: string = 'sede';


	constructor( private http: HttpClient ) {
	}

	public findMenuStatus(): Observable<MenuComedorSedeStatus[]> {
		return this.http.get<MenuComedorSedeStatus[]>( this.MENU_COMEDOR_STATUS_URL );
	}

	public findMenu( sedes: MENU_COMEDOR_SEDE[] ): Observable<MenuComedorSedeRecord[]> {
		let result: Observable<MenuComedorSedeRecord[]>;
		if( sedes?.length > 0 ) {
			let params: HttpParams = new HttpParams();
			sedes.forEach( sede => {
				params = params.append( this.SEDE_PARAM, sede );
			});
			result = this.http.get<MenuComedorSedeRecord[]>( this.MENU_COMEDOR_URL, { params } );
		} else
			result = of( null );
		return result;
	}

}